export default (
  element: Window | HTMLElement,
  eventType: 'resize' | 'click',
  delay: number,
  action: Function,
) => {
  let throttled = false;

  element.addEventListener(eventType, () => {
    if (!throttled) {
      action();
      throttled = true;
      setTimeout(() => {
        throttled = false;
      }, delay);
    }
  });
};
